import { useContext } from 'react';
import { DataHygienePhoneNumberContext } from 'assets/js/pages/contacts/data-hygiene/DataHygienePhoneNumberContext';
import { PhoneNumberUpdateForm } from 'assets/js/pages/contacts/data-hygiene/PhoneNumberUpdateForm';

const PhoneNumberUpdate = () => {
    const data = useContext(DataHygienePhoneNumberContext);
    const { deliverability_status, phone_number } = data.phone_number;

    if (deliverability_status === 'deliverable') {
        return null;
    }

    return (
        <div className="flex w-full min-w-72 flex-col gap-4 whitespace-normal">
            <div className="flex flex-col gap-1.5">
                <h3 className="font-medium text-gray-700">Current phone number</h3>
                <span className="text-gray-600">{phone_number}</span>
            </div>
            <PhoneNumberUpdateForm />
        </div>
    );
};

export { PhoneNumberUpdate };
